import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-6">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#4f7a64] border-t-transparent"></div>
    </div>
  );
}
